import styled, { css } from 'styled-components';
import { InputField } from '../InputField/InputField.styles';

type SelectFieldAttributes = {
  width: number;
};

export default styled.select(
  ({ width }: SelectFieldAttributes) => css`
    ${InputField()}
    width: ${width}%;

    > option {
      background-color: rgb(191 191 191);
      transition: background-color 0.3s;
      color: rgb(0 0 0);

      appearance: none;
      outline: none;

      border: none;
      height: 50px;

      &:hover,
      &:focus,
      &:active,
      &:checked,
      &:selected {
        background-color: rgb(255 255 255);
      }

      &:first-child {
        display: none;
      }
    }

    &:focus,
    &:active {
      border-color: rgb(0 0 0);

      > option:checked {
        background-color: rgb(255 255 255);
      }
    }
  `
);
